export const CHANGE_NAVIGATION_THEME = 'CHANGE_NAVIGATION_THEME';

export const changeNavigationTheme = (darkTheme) => ({
  type: CHANGE_NAVIGATION_THEME,
  darkTheme
});

export const CHANGE_VISIBLE_ACCOUNT_LINKS = 'CHANGE_VISIBLE_ACCOUNT_LINKS';

export const changeVisibleAccountLinks = (isVisibleAccountLinks) => ({
  type: CHANGE_VISIBLE_ACCOUNT_LINKS,
  isVisibleAccountLinks
});